export const INDICATOR_LIBRARY = {
  Health: {
    "HIV/AIDS": {
      Output: [
        { name: "Key populations reached with prevention programs", description: "Number of key populations reached with HIV prevention interventions" },
        { name: "Adolescent girls and young women reached with prevention programs", description: "AGYW reached with combination HIV prevention" },
      ],
      Outcome: [
        { name: "People living with HIV who know their status", description: "Percentage of PLHIV who know their HIV status" },
        { name: "ART coverage", description: "Percentage of PLHIV currently receiving antiretroviral therapy" },
        { name: "Viral load suppression", description: "Percentage of PLHIV on ART with suppressed viral load" },
        { name: "Elimination of vertical transmission", description: "Mother-to-child HIV transmission rate" },
        { name: "PLHIV on ART who initiated TB preventive therapy", description: "Percentage of PLHIV on ART who completed TB preventive treatment" },
      ],
      Impact: [
        { name: "HIV incidence rate", description: "New HIV infections per 1,000 uninfected population" },
        { name: "HIV mortality rate", description: "AIDS-related deaths per 100,000 population" },
      ],
    },
    "Tuberculosis": {
      Output: [
        { name: "TB notifications, all forms", description: "Total number of TB cases notified" },
      ],
      Outcome: [
        { name: "TB treatment success rate, all forms", description: "Percentage of TB patients successfully treated" },
        { name: "Drug-resistant TB treatment success rate", description: "Treatment success rate for drug-resistant TB cases" },
        { name: "TB contacts on preventive treatment", description: "Percentage of eligible TB contacts who completed preventive therapy" },
        { name: "ART coverage for HIV-positive TB patients", description: "HIV-positive TB patients on antiretroviral therapy" },
      ],
      Impact: [
        { name: "TB incidence rate", description: "New TB cases per 100,000 population per year" },
        { name: "TB mortality rate", description: "TB deaths per 100,000 population per year" },
      ],
    },
    "Malaria": {
      Output: [
        { name: "LLINs distributed", description: "Long-lasting insecticidal nets distributed to at-risk populations" },
        { name: "Malaria testing in public facilities", description: "Suspected malaria cases tested in public health facilities" },
        { name: "Malaria cases treated in public facilities", description: "Confirmed malaria cases receiving first-line treatment" },
      ],
      Outcome: [
        { name: "IPTp3 coverage", description: "Pregnant women receiving 3+ doses of intermittent preventive treatment" },
        { name: "Children receiving full course of seasonal malaria chemoprevention", description: "Children in eligible areas completing SMC cycles" },
      ],
      Impact: [
        { name: "Malaria incidence rate", description: "Confirmed malaria cases per 1,000 population at risk" },
        { name: "Malaria mortality rate", description: "Malaria deaths per 100,000 population at risk" },
      ],
    },
    "Pandemic Preparedness": {
      Output: [
        { name: "Laboratory testing capacity", description: "Number of laboratories with diagnostic testing capacity" },
      ],
      Outcome: [
        { name: "Early warning surveillance function", description: "Functional event-based surveillance systems in place" },
      ],
      Impact: [
        { name: "Pandemic response readiness level", description: "Overall pandemic preparedness index score" },
      ],
    },
    "Health Systems Strengthening": {
      Output: [
        { name: "Number of trained health workers", description: "Health workers trained in priority program areas" },
      ],
      Outcome: [
        { name: "Data-driven decision making", description: "Health facilities using data for program management decisions" },
        { name: "Systems readiness for community health workers", description: "CHW programs with functional supply and supervision systems" },
        { name: "Supply continuity", description: "Facilities with no stock-outs of essential health commodities" },
      ],
      Impact: [
        { name: "Health system efficiency improvement", description: "Improvement in health system performance metrics" },
      ],
    },
  },
  Education: {
    "Primary Education": {
      Output: [
        { name: "Number of schools constructed or rehabilitated", description: "School facilities built or renovated to meet safety and learning standards" },
        { name: "Teachers trained in pedagogy", description: "Teachers receiving professional development in student-centered teaching methods" },
        { name: "Learning materials distributed", description: "Textbooks and learning kits provided to students" },
      ],
      Outcome: [
        { name: "Net enrollment rate", description: "Percentage of school-age children enrolled in primary education" },
        { name: "Primary completion rate", description: "Percentage of students completing final year of primary school" },
        { name: "Student-teacher ratio", description: "Average number of students per qualified teacher" },
        { name: "Literacy rate among primary graduates", description: "Percentage of primary graduates meeting minimum literacy benchmarks" },
      ],
      Impact: [
        { name: "Out-of-school children rate", description: "Percentage of primary-age children not attending school" },
        { name: "Learning poverty rate", description: "Percentage of children unable to read and understand simple text by age 10" },
      ],
    },
    "Secondary Education": {
      Output: [
        { name: "Scholarships awarded", description: "Number of students receiving financial support for secondary education" },
        { name: "STEM labs established", description: "Science and technology laboratories set up in secondary schools" },
      ],
      Outcome: [
        { name: "Secondary enrollment rate", description: "Percentage of eligible youth enrolled in secondary education" },
        { name: "Secondary completion rate", description: "Percentage of enrolled students completing secondary education" },
        { name: "Gender parity index", description: "Ratio of female to male enrollment in secondary education" },
      ],
      Impact: [
        { name: "Youth unemployment rate among graduates", description: "Percentage of secondary graduates unable to find employment within 12 months" },
        { name: "Transition rate to tertiary education", description: "Percentage of secondary graduates enrolling in higher education" },
      ],
    },
    "Vocational Training": {
      Output: [
        { name: "Trainees enrolled in vocational programs", description: "Number of youth and adults enrolled in skills training" },
        { name: "Training centers equipped", description: "Facilities upgraded with tools and machinery for practical skills" },
      ],
      Outcome: [
        { name: "Certification rate", description: "Percentage of trainees completing and receiving certification" },
        { name: "Employment rate post-training", description: "Percentage of graduates employed within 6 months" },
      ],
      Impact: [
        { name: "Income improvement among graduates", description: "Average income change for trained individuals versus baseline" },
      ],
    },
    "Girls' Education": {
      Output: [
        { name: "Girls enrolled through targeted programs", description: "Number of girls enrolled via dedicated education initiatives" },
        { name: "Menstrual hygiene kits distributed", description: "Hygiene supplies provided to reduce school absenteeism" },
      ],
      Outcome: [
        { name: "Girls' attendance rate", description: "Average school attendance rate for enrolled girls" },
        { name: "Girls' completion rate", description: "Percentage of enrolled girls completing the education cycle" },
        { name: "Reduction in child marriage rate", description: "Change in early marriage prevalence in target communities" },
      ],
      Impact: [
        { name: "Female literacy rate improvement", description: "Change in female literacy levels in project areas" },
      ],
    },
  },
  WASH: {
    "Water Supply": {
      Output: [
        { name: "Water points constructed", description: "New boreholes, wells, or piped water systems installed" },
        { name: "Water systems rehabilitated", description: "Existing non-functional water systems restored" },
        { name: "Households connected to water supply", description: "Number of households gaining access to improved water" },
      ],
      Outcome: [
        { name: "Population with access to safe drinking water", description: "Percentage of target population using improved water sources" },
        { name: "Water quality compliance rate", description: "Percentage of water points meeting national quality standards" },
        { name: "Water supply continuity", description: "Hours per day of water availability at improved sources" },
      ],
      Impact: [
        { name: "Waterborne disease incidence reduction", description: "Reduction in diarrheal and waterborne disease cases" },
        { name: "Time saved in water collection", description: "Average reduction in hours spent collecting water per household" },
      ],
    },
    "Sanitation": {
      Output: [
        { name: "Latrines constructed", description: "Improved household or community latrines built" },
        { name: "Schools with improved sanitation facilities", description: "Schools provided with gender-separated, accessible toilets" },
      ],
      Outcome: [
        { name: "Open defecation free communities", description: "Number of communities certified as ODF" },
        { name: "Household access to improved sanitation", description: "Percentage of households using improved sanitation facilities" },
      ],
      Impact: [
        { name: "Reduction in child stunting", description: "Change in under-5 stunting rates linked to improved sanitation" },
      ],
    },
    "Hygiene Promotion": {
      Output: [
        { name: "Hygiene awareness sessions conducted", description: "Community sessions on handwashing and hygiene practices" },
        { name: "Handwashing stations installed", description: "Stations with soap and water placed in public areas" },
      ],
      Outcome: [
        { name: "Handwashing practice rate", description: "Percentage of population practicing handwashing at critical times" },
        { name: "Hygiene knowledge improvement", description: "Increase in correct hygiene knowledge among target communities" },
      ],
      Impact: [
        { name: "Reduction in acute respiratory infections", description: "Decrease in ARI cases attributable to improved hygiene" },
      ],
    },
  },
  "Food Security": {
    "Agricultural Productivity": {
      Output: [
        { name: "Farmers trained in improved techniques", description: "Smallholder farmers receiving training on modern farming practices" },
        { name: "Seeds and inputs distributed", description: "Improved seeds, fertilizers, and tools provided" },
        { name: "Irrigation systems installed", description: "Small-scale or drip irrigation systems set up" },
      ],
      Outcome: [
        { name: "Crop yield increase", description: "Percentage improvement in yield per hectare for target crops" },
        { name: "Adoption of improved agricultural practices", description: "Percentage of trained farmers applying new techniques" },
        { name: "Post-harvest loss reduction", description: "Decrease in crop losses during storage and handling" },
      ],
      Impact: [
        { name: "Food insecurity prevalence reduction", description: "Change in food insecurity levels in project communities" },
        { name: "Household dietary diversity score", description: "Improvement in variety of food groups consumed by households" },
      ],
    },
    "Nutrition": {
      Output: [
        { name: "Children screened for malnutrition", description: "Under-5 children assessed for acute and chronic malnutrition" },
        { name: "Supplementary feeding beneficiaries", description: "Malnourished children and mothers receiving therapeutic or supplementary food" },
      ],
      Outcome: [
        { name: "Prevalence of acute malnutrition", description: "Percentage of children under 5 with global acute malnutrition" },
        { name: "Exclusive breastfeeding rate", description: "Percentage of infants exclusively breastfed for first 6 months" },
        { name: "Vitamin A supplementation coverage", description: "Children 6-59 months receiving vitamin A supplements" },
      ],
      Impact: [
        { name: "Under-5 stunting rate", description: "Percentage of children under 5 with chronic malnutrition" },
        { name: "Under-5 mortality rate", description: "Deaths per 1,000 live births attributable to malnutrition" },
      ],
    },
    "Food Distribution": {
      Output: [
        { name: "Metric tons of food distributed", description: "Volume of food aid delivered to target populations" },
        { name: "Beneficiaries receiving food assistance", description: "Individuals or households receiving food rations or vouchers" },
      ],
      Outcome: [
        { name: "Food consumption score improvement", description: "Change in food consumption patterns among beneficiaries" },
        { name: "Coping strategy index reduction", description: "Decrease in negative food coping behaviors" },
      ],
      Impact: [
        { name: "Household food security index", description: "Overall food security status of target population" },
      ],
    },
  },
  "Economic Development": {
    "Microfinance & Livelihoods": {
      Output: [
        { name: "Microloans disbursed", description: "Number of small loans issued to entrepreneurs and small businesses" },
        { name: "Savings groups established", description: "Community savings and lending groups formed" },
        { name: "Business skills training participants", description: "Individuals trained in financial literacy and entrepreneurship" },
      ],
      Outcome: [
        { name: "Loan repayment rate", description: "Percentage of microloans repaid on time" },
        { name: "New businesses established", description: "Number of new enterprises started by program participants" },
        { name: "Average income increase", description: "Percentage improvement in monthly income for beneficiaries" },
      ],
      Impact: [
        { name: "Poverty rate reduction", description: "Change in population below national poverty line in target area" },
        { name: "Economic self-sufficiency rate", description: "Percentage of beneficiaries achieving financial independence" },
      ],
    },
    "Employment & Skills": {
      Output: [
        { name: "Job placements facilitated", description: "Individuals connected to employment opportunities" },
        { name: "Apprenticeships created", description: "Structured on-the-job training positions established" },
      ],
      Outcome: [
        { name: "Employment rate among beneficiaries", description: "Percentage of program participants in stable employment" },
        { name: "Wage improvement rate", description: "Average wage increase for participants versus control group" },
      ],
      Impact: [
        { name: "Local unemployment rate change", description: "Reduction in unemployment in project area" },
      ],
    },
    "Market Access": {
      Output: [
        { name: "Market infrastructure built", description: "Market stalls, storage facilities, or roads constructed" },
        { name: "Farmer cooperatives supported", description: "Producer groups receiving organizational and market linkage support" },
      ],
      Outcome: [
        { name: "Producer income from market sales", description: "Revenue increase for smallholders selling through improved channels" },
        { name: "Market participation rate", description: "Percentage of target producers accessing formal markets" },
      ],
      Impact: [
        { name: "Regional trade volume increase", description: "Growth in local economic activity and trade" },
      ],
    },
  },
};

export const CATEGORIES = Object.keys(INDICATOR_LIBRARY);

export function getFocusAreas(category) {
  return category && INDICATOR_LIBRARY[category] ? Object.keys(INDICATOR_LIBRARY[category]) : [];
}

export function getIndicators(category, focusArea) {
  if (!category || !focusArea || !INDICATOR_LIBRARY[category]?.[focusArea]) return {};
  return INDICATOR_LIBRARY[category][focusArea];
}

export const INDICATOR_TYPES = ["Output", "Outcome", "Impact"];

export const TYPE_COLORS = {
  Output: { bg: "bg-sky-50", text: "text-sky-700", border: "border-sky-200", badge: "bg-sky-100 text-sky-700" },
  Outcome: { bg: "bg-amber-50", text: "text-amber-700", border: "border-amber-200", badge: "bg-amber-100 text-amber-700" },
  Impact: { bg: "bg-violet-50", text: "text-violet-700", border: "border-violet-200", badge: "bg-violet-100 text-violet-700" },
  Input: { bg: "bg-emerald-50", text: "text-emerald-700", border: "border-emerald-200", badge: "bg-emerald-100 text-emerald-700" },
};
